/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ discount: NonNullable<unknown> }} Partner_Manage_Badge_SaveInputs */



/**
* | output |
* | --- |
* | "Save {discount}" |
*
* @param {Partner_Manage_Badge_SaveInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_manage_badge_save = /** @type {((inputs: Partner_Manage_Badge_SaveInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Manage_Badge_SaveInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.discount} sparen`)
	return /** @type {LocalizedString} */ (`Save ${i?.discount}`)
});